import NotificationBanner from '../shared/NotificationBanner';

export default function AIConnectionBanner({ onResolve }) {
  return (
    <NotificationBanner
      title="AI Connection Required"
      subtitle="Configure AI to enable chat features"
      severity="warning"
      onResolve={onResolve}
      resolveText="Resolve"
    />
  );
}
